import { SelectableItem } from "@/src/components/action-modals/item-selection/item-row";
import { CloseCircle } from "iconsax-react-nativejs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Image, Pressable, Text, View } from "react-native";
import { capitalizeName } from "@/src/utils/string.utils";

type ItemChipsProps = Readonly<{
  items: SelectableItem[];
  onRemove: (id: string) => void;
  maxVisible?: number;
}>;

const ScChips = ({ items, onRemove, maxVisible = 5 }: ItemChipsProps) => {
  const [showAll, setShowAll] = useState(false);
  const { t } = useTranslation();

  const visible = showAll ? items : items.slice(0, maxVisible);
  const extraCount = items.length - maxVisible;
  return (
    <View className="flex-row flex-wrap gap-2">
      {visible.map((item) => (
        <View
          key={item.itemId}
          className="flex-row items-center gap-1 bg-chalk border border-ash-3 rounded-full px-2 py-1"
        >
          <Image
            source={
              item.profileImageUrl
                ? { uri: item.profileImageUrl }
                : require("@/src/assets/images/default-group-profile.png")
            }
            className="rounded-full"
            style={{ height: 20, width: 20 }}
          />
          <Text className="text-sm text-onyx">
            {capitalizeName(item.displayName) || item.userName}
          </Text>
          <Pressable
            onPress={() => onRemove(item.itemId)}
            hitSlop={8}
            className="rounded-full hover:bg-ash-3"
          >
            <CloseCircle className="text-gray-light-2" />
          </Pressable>
        </View>
      ))}

      {!showAll && extraCount > 0 && (
        <Pressable
          onPress={() => setShowAll(true)}
          className="items-center justify-center bg-ash rounded-full px-2 py-1 hover:bg-ash-3"
        >
          <Text className="text-sm text-slate">{`+${extraCount} ${t("LABEL_MORE")}`}</Text>
        </Pressable>
      )}

      {showAll && items.length > maxVisible && (
        <Pressable
          onPress={() => setShowAll(false)}
          className="items-center justify-center bg-ash rounded-full px-2 py-1 hover:bg-ash-3"
        >
          <Text className="text-sm text-slate">{t("LABEL_SEE_LESS")}</Text>
        </Pressable>
      )}
    </View>
  );
};

export default ScChips;
